import { __require as require_getNative } from './_getNative.js';
import { __require as require_root } from './_root.js';

var _DataView;
var hasRequired_DataView;

function require_DataView () {
	if (hasRequired_DataView) return _DataView;
	hasRequired_DataView = 1;
	var getNative = require_getNative(),
	    root = require_root();

	/* Built-in method references that are verified to be native. */
	var DataView = getNative(root, 'DataView');

	_DataView = DataView;
	return _DataView;
}

export { require_DataView as __require };
//# sourceMappingURL=_DataView.js.map
